import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useOutsideClick from "@hooks/useOutsideClick";
import useSearchInputWithSuggestions from "@hooks/useSearchInputWithSuggestions";
import useTranslations from "@hooks/useTranslations";
import SearchSuggestions from "@widgets/header/search/SearchSuggestions";
import { useEffect, useRef } from "react";
import { RiSearch2Line } from "react-icons/ri";
export const SearchField = (props) => {
    const { initialSearchText, shouldShowSuggestions, onSearch, onToggle } = props;
    const { t } = useTranslations();
    const inputRef = useRef(null);
    const searchFieldRef = useRef([]);
    useOutsideClick({
        refs: searchFieldRef,
        callback: () => {
            if (!shouldShowSuggestions) {
                return;
            }
            onToggle(false);
        }
    });
    const { handleSearchChanges, loading, searchSuggestions, baseSearchUrl, searchValue } = useSearchInputWithSuggestions();
    const handleClick = () => {
        return onSearch(inputRef.current.value);
    };
    const handleEnter = (key) => {
        if (key === "Enter") {
            onSearch(inputRef.current.value);
        }
    };
    useEffect(() => {
        inputRef.current.value = initialSearchText;
    }, [initialSearchText]);
    return (_jsxs("div", { className: "relative flex items-center", ref: (ref) => searchFieldRef.current.splice(0, searchFieldRef.current.length, ref), children: [_jsx("input", { ref: inputRef, type: "text", onChange: (ev) => handleSearchChanges(ev.target.value), onKeyUp: (ev) => handleEnter(ev.key), onFocus: () => onToggle(true), id: "search_field", className: "search-field peer shadow-bdo-lg", placeholder: " ", autoComplete: "off" }), _jsx("label", { htmlFor: "search_field", className: "search-field-label", children: t("BDO.LiveSite.Header.Search") }), _jsx("div", { className: "search-field-icon", onClick: handleClick, children: _jsx(RiSearch2Line, {}) }), _jsx("button", { type: "button", className: "hidden", onClick: handleClick, children: t("BDO.LiveSite.Submit") }), _jsx(SearchSuggestions, { isVisible: shouldShowSuggestions, searchValue: searchValue, searchSuggestions: searchSuggestions, searchPageUrl: baseSearchUrl, loading: loading, className: "header__search-results" })] }));
};
